/**
 * TopBar dismiss — .top-bar
 * 點關閉鈕 → 收合公告列（.top-bar--dismissed: display:none），localStorage 記住不再出現。
 *
 * - storage key 'top-bar:dismissed'（沿用 compare-bar:items 的 colon-namespace 慣例）
 * - localStorage 包 try/catch：無痕模式 / 停用儲存 不會 throw 中斷
 * - 收合 = display:none，高度歸零。nav 定位與 top-bar 收合無耦合：首頁 reveal 由
 *   hero-immersion.js 觀察 .hero 驅動、內頁 nav 常駐 sticky（不靠位移觸發）→ 無需通知 nav，
 *   故不再 dispatch 任何事件。hero-immersion.js 另以 MutationObserver 監看 top-bar class/style
 *   變動重量沉浸層高度（獨立路徑）。
 */

const STORAGE_KEY = 'top-bar:dismissed';

const topBar = document.querySelector('[data-top-bar]');

if (topBar) {
  const closeBtn = topBar.querySelector('[data-top-bar-close]');

  const readDismissed = () => {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  };

  const persistDismissed = () => {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch {
      /* 儲存不可用：本次仍收合，僅無法跨重整記住 */
    }
  };

  // 初始：曾關閉過則直接隱藏（早於使用者看到）。
  // 同步在 <html> 掛 .top-bar-dismissed → 手機沉浸版 chrome 帶位（--ovl-*，見 hero.css）
  // 於首屏渲染前就 reflow 到頂，重整（已關閉）不閃白帶、無 CLS。
  if (readDismissed()) {
    topBar.classList.add('top-bar--dismissed');
    document.documentElement.classList.add('top-bar-dismissed');
  }

  closeBtn?.addEventListener('click', () => {
    topBar.classList.add('top-bar--dismissed');
    // 手機沉浸版：公告列 display:none 後留下 0..--ovl-nav-top 的空 navy 帶（nav 仍釘在舊帶位）。
    // 在 <html> 掛 .top-bar-dismissed 讓 hero.css 的 dismissed override 生效，把 nav/search/hero
    // 內容帶位往上收到頁頂（桌機無此 override，byte-identical 不受影響）。
    document.documentElement.classList.add('top-bar-dismissed');
    persistDismissed();
    // nav 定位（首頁 reveal / 內頁 sticky 常駐）與 top-bar 收合無耦合，
    // hero-immersion 由 MutationObserver 自行重量 → 無需在此 dispatch 事件。
  });
}
